var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWrongTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81614 5.98089L0.349776 1.44743C0.0269058 1.11971 0.0269058 0.57351 0.349776 0.24579C0.672646 -0.08193 1.21076 -0.08193 1.53363 0.24579L6 4.77925L10.4664 0.24579C10.7892 -0.08193 11.3274 -0.08193 11.6502 0.24579C11.9731 0.57351 11.9731 1.11971 11.6502 1.44743L7.18386 5.98089L11.7578 10.6236C12.0807 10.9513 12.0807 11.4975 11.7578 11.8252C11.435 11.9345 11.2197 12.0437 11.1121 12.0437C10.8969 12.0437 10.6816 11.9345 10.574 11.8252L6 7.18253L1.42601 11.8252C1.21076 11.9345 0.995516 12.0437 0.780269 12.0437C0.565022 12.0437 0.349776 11.9345 0.242152 11.8252C-0.0807175 11.4975 -0.0807175 10.9513 0.242152 10.6236L4.81614 5.98089Z",
    fill: "#E84F48"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWrongTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wrong-tick.f4d3836d.svg";
export { ForwardRef as ReactComponent };